import styled from '@emotion/styled'
import React, {
  ButtonHTMLAttributes,
  ComponentProps,
  forwardRef,
  Ref,
} from 'react'

import { overrideOptional } from '@emico/overrides'
import { testId } from '@emico/utils'

import Button, { useHandleClick } from './Button'

const StyledButton = styled.button`
  background: none;
  border: none;
  font: inherit;
  margin: 0;
  padding: 0;

  &:focus {
    outline: none;
  }

  &:hover,
  &:active,
  &:disabled {
    background: none;
  }
`

type ButtonUnstyledProps = Pick<
  ComponentProps<typeof Button>,
  'analyticsName' | 'analyticsContext' | 'onClick' | 'children' | 'as'
> &
  ButtonHTMLAttributes<HTMLButtonElement>

const ButtonUnstyled = (
  { analyticsName, analyticsContext, onClick, ...props }: ButtonUnstyledProps,
  ref: Ref<HTMLButtonElement>,
) => {
  const handleClick = useHandleClick(analyticsName, analyticsContext, onClick)
  return (
    <StyledButton
      onClick={handleClick}
      data-testid={testId(analyticsName, analyticsContext)}
      ref={ref}
      {...props}
    />
  )
}

export default overrideOptional(forwardRef(ButtonUnstyled))
